import { render, staticRenderFns } from "./ApplicationFlowWaitingRoom.vue?vue&type=template&id=bff4b188&scoped=true&"
import script from "./ApplicationFlowWaitingRoom.vue?vue&type=script&lang=js&"
export * from "./ApplicationFlowWaitingRoom.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationFlowWaitingRoom.vue?vue&type=style&index=0&id=bff4b188&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff4b188",
  null
  
)

export default component.exports